<template>
  <div class="con">
    <!-- 主播选择组件 -->
    <RealAnchor @user="useAnchor" @mb="showRealAnchor(false)" v-show="show_realAnchor" />
    <!-- 头部部分 -->
    <div class="real_flexDR real_flexSB real_dub_con" >
      <div class="dubbing_boxHead dubbing_marT24 real_flexSB real_flexAC dubbing_marR24 ">
        <div class="real_flexDR" v-if="real_anchor.cover">
          <img :src="real_anchor.cover" alt="" class="real_marR20 index_mod2_liavater dubbing_marL16"/>
          <div>
            <div class="real_flexDR real_flexAC">
              <p class="fontS16 dubbing_marR16">
                {{ real_anchor.speakername }}
              </p>
              <p class="fontS12 dubbing_fontCR">
                ({{ real_anchor.price }}元/百字)
              </p>
            </div>
            <div class="dubbing_fontCF">
              所选案例：{{ chose_music.soundname }}
            </div>
          </div>
        </div>

        <div class="real_unChose" v-else>
            <img src="../../assets/images/unLogin.png" alt="" class="real_marR20 index_mod2_liavater dubbing_marL16">
            <p>未选择主播</p>
        </div>

        <!-- <router-link to="/real"> -->
          <div class="fontS12 dubbing_but" @click="showrealAnchorView()">更换主播</div>
        <!-- </router-link> -->
      </div>

      <div class="dubbing_boxHead dubbing_marT24 real_flexSB real_flexAC dubbing_marR24">
        <div v-if="bgd_music.bgname" class="real_flexDR">
          <img src="../../assets/images/img1/dubbing_music.png" alt="" class="real_marR20 dubbing_liavater dubbing_marL16"/>
          <div class="real_flexAC real_flexWW real_bcgText">
            <div class="">
              <p class="fontS16 dubbing_marR16 overflow_hide real_bcgText" >
                {{ bgd_music.bgname }}
              </p>
              <!-- <p class="fontS16 dubbing_marR16">默认无背景音</p> -->
            </div>
            <div class="dubbing_fontCF" v-if="bgd_music.bgtimelen">
              时长：{{ formatDuring(bgd_music.bgtimelen) }}
            </div>
          </div>
        </div>
         <div v-else class="dubbing_flexDR">
            <img src="../../assets/images/img1/dubbing_music.png" class="real_marR20 dubbing_liavater dubbing_marL16"/>
            <div>未选择背景音乐</div>
        </div>
        <div class="fontS12 dubbing_but" @click="openMask">
            {{ bgd_music.bgid ? "更换音乐" : "选择音乐" }}
        </div>
      </div>

      <div
        class="
          dubbing_boxHead dubbing_marT24
          real_flexSB real_flexAC
          dubbing_marR24
        "
      >
        <div class="real_flexDR">
          <img
            src="../../assets/images/img1/dubbing_vidio.png"
            alt=""
            class="real_marR20 dubbing_liavater dubbing_marL16"
          />
          <div>
            <div class="">
              <p class="fontS16 dubbing_marR16">配音视频</p>
            </div>
            <div class="dubbing_fontCF">添加需额外支付100元</div>
          </div>
        </div>
        <div
          class="fontS12 dubbing_but"
          @click="video_info.bgmusicurl ? clearFileInfo() : (showModal_video = true)"
        >
          {{ video_info.bgmusicurl ? "取消视频" : "添加视频" }}
        </div>
      </div>

      <div
        class="dubbing_headKF dubbing_marT24 real_flexAC"
        @click="customerService"
      >
        <img
          src="../../assets/images/img1/dubbing_service.png"
          alt=""
          class="real_marR20 dubbing_liavater dubbing_marL16"
        />
        <div class="fontS16">联系客服</div>
      </div>
    </div>
    <div class="real_flexDR real_he">
      <div class="dubbing_lift">
        <textarea
          class="dubbing_text"
          placeholder="请输入内容"
          maxlength="5000"
          @input="descInput"
          v-model="desc"
        />
        <div class="real_flexSB">
          <span class="real_fontC1"
            >温馨提示：老师工作时间为周一至周五，9:00 ——
            18:00；如遇节假日和周末，订单会顺延至下一工作日完成。</span
          >
          <span class="real_fontC1">字数：{{ remnant }}/5000</span>
        </div>
      </div>
      <div class="dubbing_right dubbing_marB16">
        <div class="real_flexDR real_flexAC dubbing_marB16">
          <p class="dubbing_star">*</p>
          <p class="dubbing_marR10 fontS16">手机</p>
          <textarea
            placeholder="请输入手机号码"
            class="dubbing_phone"
            rows="1"
            v-model="phonenum"
          ></textarea>
        </div>
        <div class="real_flexDR dubbing_marB16">
          <p class="dubbing_marR16 fontS16 dubbing_marT6">语速</p>
          <textarea
            class="dubbing_yusu"
            placeholder="请用简洁语言描写想要的效果（可不添加）"
            v-model="speed"
          ></textarea>
        </div>
        <div class="real_flexDR dubbing_marB16">
          <p class="dubbing_marR16 fontS16 dubbing_marT6">音量</p>
          <textarea
            class="dubbing_yusu"
            placeholder="请用简洁语言描写想要的效果（可不添加）"
            v-model="volume"
          ></textarea>
        </div>
        <div class="real_flexDR dubbing_marB16">
          <p class="dubbing_marR16 fontS16 dubbing_marT6">情感</p>
          <textarea
            class="dubbing_yusu"
            placeholder="请用简洁语言描写想要的效果（可不添加）"
            v-model="feeling"
          ></textarea>
        </div>
        <div class="real_flexDR dubbing_marB16">
          <p class="dubbing_marR16 fontS16 dubbing_marT6">其他</p>
          <textarea
            class="dubbing_yusu"
            placeholder="请用简洁语言描写想要的效果（可不添加）"
            v-model="remarks"
          ></textarea>
        </div>
        <div
          class="real_flexJC dubbing_button fontS14 hover_hand"
          @click="setRealWork"
        >
          提交需求
        </div>
      </div>
    </div>

    <!-- 添加音乐弹框 -->
    <Bgdmusic
      v-model="sendVal"
      @selectBgmusic="selectBgmusic"
      @clearBgmusic="clearBgmusic"
    ></Bgdmusic>

    <!-- 添加视频弹框 -->
    <div
      class="mb real_flexJC real_flexAC"
      v-if="showModal_video"
      v-loading="loading"
    >
      <div class="dubbing_videoUp">
        <div class="real_flexSB dubbing_marB16">
          <p>上传视频</p>
          <img
            src="../../assets/images/img1/dubbing_close.png"
            alt=""
            style="width: 14px; height: 14px"
            @click="showModal_video = false"
          />
        </div>
        <div
          class="dubbing_choseMV real_flexAC real_flexJC real_flexDC"
          v-if="file.name"
        >
          {{ file.name }}
        </div>
        <div class="dubbing_choseMV real_flexAC real_flexJC real_flexDC" v-else>
          <img
            src="../../assets/images/img1/dubbing_fileDark.png"
            alt=""
            style="width: 56px; height: 56px"
          />
          <p class="fontS16">从本地选择</p>
          <p class="fontS12 real_fontC1">视频配音需额外支付100元</p>
          <input
            type="file"
            name="file"
            id="upfile"
            @change="setFile($event)"
          />
        </div>
        <div class="dubbing_upBtn" @click="getFile()">上传</div>
      </div>
    </div>

    <!-- 付款弹框 -->
    <div class="real_flexJC real_flexAC mb" v-if="showModal_pay">
      <div class="dubbing_pay">
        <div class="real_flexSB">
          <div style="width: 14px"></div>
          <div class="real_flexJC real_flexDC">
            <p class="fontS18 dubbing_center">等待付款</p>
            <p class="fontS12 real_fontC1 dubbing_center">
              声24小时0分钟自动取消
            </p>
          </div>
          <img
            src="../../assets/images/img1/dubbing_close.png"
            alt=""
            style="width: 14px; height: 14px"
            @click="hidePay"
          />
        </div>

        <div class="real_flexSA dubbing_marT20 dubbing_marB16">
          <div class="dubbing_imgBox">
            <img
              class="dubbing_imgWT"
              src="../../assets/images/img1/dubbing_wallet.png"
              alt=""
            />
            <p class="fontS12">待支付</p>
          </div>
          <div class="dubbing_imgBoxProgress">
            <img
              class="dubbing_imgWT"
              src="../../assets/images/img1/dubbing_huatong.png"
              alt=""
            />
            <p class="fontS12">配音中</p>
          </div>
          <div class="dubbing_imgBoxProgress">
            <img
              class="dubbing_imgWT"
              src="../../assets/images/img1/dubbing_start.png"
              alt=""
            />
            <p class="fontS12">完成</p>
          </div>
        </div>
        <hr style="border-top: 1px solid #eeeeeeff" />

        <div class="dubbing_marT20 real_flexSB real_flexAC">
          <div class="real_flexDR">
            <img
              :src="real_anchor.cover"
              alt=""
              class="real_marR20 index_mod2_liavater dubbing_marL16"
            />
            <div>
              <div class="real_flexAC">
                <p class="fontS16 dubbing_marR16">
                  {{ real_anchor.speakername }}
                </p>
              </div>
              <div class="dubbing_fontCF">{{ chose_music.soundname }}</div>
            </div>
          </div>
          <div class="real_pad20">
            <p class="fontS12 dubbing_fontCR">
              ({{ real_anchor.price }}元/百字)
            </p>
          </div>
        </div>

        <div class="real_flexSB dubbing_marT10">
          <div class="real_flexDR dubbing_marL20">
            <p class="real_fontC3 fontS14 dubbing_marR16">配音字数</p>
            <p class="real_fontC1 fontS14">共{{ remnant }}字</p>
          </div>
          <!-- <div class="real_fontC3 fontS14 dubbing_marR20">查看文案</div> -->
        </div>

        <div class="real_flexSB dubbing_marT10">
          <div class="real_flexDR dubbing_marL20">
            <p class="real_fontC3 fontS14 dubbing_marR20">配音视频</p>
            <p class="real_fontC1 fontS14 overflow_hide videocon">
              {{ video_info.bgmusicurl!==undefined ? video_info.bgmusicurl : "未添加" }}
            </p>
          </div>
          <div class=""></div>
        </div>

        <div class="real_flexSB dubbing_marT10">
          <div class="real_flexDR dubbing_marL20">
            <p class="real_fontC3 fontS14 dubbing_marR16">订单金额</p>
            <p class="real_fontC1 fontS14">配音字数</p>
          </div>
          <div class="real_fontC3 fontS14 dubbing_marR20">
            ￥{{ text_total }}
          </div>
        </div>
        <div class="real_flexSB dubbing_marT10" v-if="video_info.bgmusicurl!==undefined">
          <div class="real_flexDR dubbing_marL20">
            <div style="width: 72px"></div>
            <p class="real_fontC1 fontS14">配音视频</p>
          </div>
          <div class="real_fontC3 fontS14 dubbing_marR20">￥100</div>
        </div>

        <div class="real_flexSB dubbing_marT10 dubbing_marB16">
          <div class="real_flexDR dubbing_marL20">
            <p class="fontS14 dubbing_marR16">合计</p>
            <p class="real_fontC1 fontS14"></p>
          </div>
          <div class="real_fontC3 fontS14 dubbing_marR20">￥{{ total }}</div>
        </div>
        <hr style="border-top: 1px solid #eeeeeeff" />
        <div class="real_flexSA real_pad20">
          <div>
            <div class="dubbing_code" v-loading="code_loading">
              <img :src="code_url" v-show="code_url" />
            </div>
            <div class="real_flexDR real_flexAC real_flexJC dubbing_marT10">
              <img
                src="../../assets/images/img1/dubbing_wechatPay.png"
                alt=""
                style="width: 13px; height: 13px; margin-right: 4px"
              />
              <p class="fontS12 real_fontC1">微信支付</p>
            </div>
          </div>
          <!-- <div>
            <div class="dubbing_code"></div>
            <div class="real_flexDR real_flexAC real_flexJC">
              <img
                src="../../assets/images/img1/dubbing_zhifubaoPay.png"
                alt=""
                style="width: 13px; height: 13px; margin-right: 4px"
              />
              <p class="fontS12 real_fontC1 dubbing_marT10">支付宝支付</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <RealCode v-if="show_code" @hide="show_code=false"/>
  </div>
</template>

<script>
// 引入背景音乐弹框组件
import Bgdmusic from "../../components/bgdmusic.vue";
import RealAnchor from "../../components/realAnchor.vue";
import RealCode from "../../components/realcode.vue";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    Bgdmusic,
    RealAnchor,
    RealCode,
  },
  computed: {
    ...mapState(["real_anchor", "chose_music", "bgd_music", "show_realAnchor"]),
  },
  destroyed() {
    clearInterval(this.paytime);
  },
  mounted() {
    //   console.log(this.$store.state.real_anchor)
      if (!this.$store.state.real_anchor) {
        this.$router.replace('/real')
      }
  },
  data() {
    return {
      file: {}, // 选择的本地文件
      video_info: {}, // 上传后的视频信息
      loading: false, // 上传文件动画显示状态
      code_loading: false, // 支付二维码加载动画显示状态
      desc: "", // 配音内容
      remnant: 0, // 配音字数
      sendVal: false, // 背景音乐组件显示状态
      showModal_video: false, // 视频上传弹窗显示状态
      showModal_pay: false, // 支付弹窗显示状态
      remarks: "", //其他要求
      phonenum: "", //手机号码
      speed: "", //语速
      volume: "", //音量
      feeling: "", //情感
      wkid: "", //制作配音作品的id(用于请求支付订单)
      text_total: 0, //字数价格
      total: 0, //配音总价
      code_url: "", //二维码图片地址
      crgid: "", //支付订单id
      show_code:false,//客服二维码显示状态
    };
  },
  methods: {
    ...mapMutations(["showRealAnchor"]),
    // 更换主播弹框
    showrealAnchorView() {
        this.$store.commit("showRealAnchor", true);
    },
    // 使用主播
    useAnchor(item) {
      this.$store.commit("showRealAnchor", false);
    //   if (item.isemotion == "1") this.mood = JSON.parse(item.emotion)[0];
    },
    // 清除文件信息
    clearFileInfo() {
      this.file = '';
      this.video_info.bgmusicurl = '';
    },
    // 关闭支付
    hidePay() {
      this.showModal_pay = false;
      clearInterval(this.paytime);
    },
    // 提交需求
    setRealWork() {
      if (this.phonenum == "") {
        this.$message({
          message: "手机号码不能为空",
          type: "warning",
        });
        return;
      }
      if (this.desc == "") {
        this.$message({
          message: "配音内容不能为空",
          type: "warning",
        });
        return;
      }
      if (!this.real_anchor.speakerid) {
        this.$message({
          message: "配音主播信息异常请更换主播",
          type: "warning",
        });
        return;
      }
      let self = this;
      let json = {
        model4LiveWork: {
          voicetext: this.desc,
          speakerid: this.real_anchor.speakerid,
          speakername: this.real_anchor.speakername,
          remarks: this.remarks,
          bgmusic: this.bgd_music.bgmusicurl!==undefined ? this.bgd_music.bgmusicurl : "",
          phonenum: this.phonenum,
          speed: this.speed,
          volume: this.volume,
          feeling: this.feeling,
          videourl: this.video_info.bgmusicurl!==undefined
            ? this.video_info.bgmusicurl
            : "",
        },
      };
      let url =
        self.$store.state.app_api + self.$store.state.app_url.crtlivework;
      self.code_loading = true;
      this.$request.postHttp(json, url, (decData) => {
        self.wkid = decData.model.wkid;
        self.showModal_pay = true;
        // 单字数的价格
        self.text_total =
          Math.ceil(Number(self.remnant) / 100) *
          Number(self.real_anchor.price);
        // 总价（有视频就加上视频的100块）
        self.total =
          Math.ceil(Number(self.remnant) / 100) *
          Number(self.real_anchor.price);
        if (self.video_info.bgmusicurl!==undefined) self.total = Number(self.total) + 100;
        self.$globalFun.getPay(
          self,
          2,
          2,
          "配音小程序网站-真人配音",
          self.total,
          2,
          self.wkid,
          {},
          (res) => {
            self.code_url = res.model.orderparams4webchat.code_url;
            self.crgid = res.model.crgid;
            self.code_loading = false;
            self.verifyPay();
          }
        );
      });
    },
    // 验证支付
    verifyPay() {
      let self = this;
      clearInterval(self.paytime);
      this.paytime = setInterval(() => {
        if (self.crgid == "") return;
        let url =
          self.$store.state.base_api + self.$store.state.base_url.qryorderinfo;
        let json = {
          crgid: self.crgid,
        };
        self.$request.postHttp(json, url, (decdata) => {
          if (decdata.model.status !== "1") return;
          //支付成功清除计时器
          clearInterval(self.paytime);
          self.showModal_pay = false;
          self.$alert("订单支付成功，配音详情请联系客服", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.replace(`/user/userreal`);
            },
          });
        });
      }, 3000);
    },
    // 联系客服
    customerService() {
      this.show_code = !this.show_code
    },
    //从本地选择文件
    setFile(e) {
      this.file = e.target.files[0];
    },
    // 上传文件
    getFile() {
      let self = this;
      this.loading = true;
      this.$globalFun.getFile(this.file, (res) => {
        console.log(res)
        self.loading = false;
        if (res.data.model.ismax == "1") {
          self.$message({
            message: "文件大小大于20M，无法上传！",
            type: "warning",
          });
        } else if (res.data.model.ismax == "0") {
          self.video_info = res.data.model;
          self.showModal_video = false;
        } else {
          self.$message.error("文件上传失败");
        }
      });
    },
    // 格式化背景音乐时长
    formatDuring(mss) {
      return this.$globalFun.formatDuring(mss);
    },
    // 选择背景音乐
    selectBgmusic(bgcMusic) {
      this.$store.commit("setBgdMusic", bgcMusic);
      this.sendVal = false;
    },
    // 取消背景音乐
    clearBgmusic() {
      this.$store.commit("setBgdMusic", {});
      this.sendVal = false;
    },
    // 显示背景音乐组件
    openMask(index) {
      this.sendVal = true;
    },
    // 配音文字输入事件
    descInput() {
      var txtVal = this.desc.replace(/\s*|\t|\r|\n/g,'');
      this.remnant = txtVal.length;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/real/real_dubbing.vue